<template>
  <div style="overflow: hidden">
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-- Variação -->
      <div class="vx-row mb-6 mt-6">
        <div class="vx-col w-full">
          <span>Variação</span>
          <v-select
            class="style-chooser"
            :options="maquinaStatusVariacoes"
            name="Variação"
            id="Variação"
            v-model="formCadastro.idVariacao"
            :reduce="(item) => item.id"
            v-validate="{ required: true }"
            :state="validateState(this.veeFields, this.veeErrors, 'Variação')"
            :class="validateClass(this.veeFields, this.veeErrors, 'Variação')"
            @option:selected="limpaJsonFacilitador()"
          ></v-select>
        </div>
      </div>

      <!-- Com Cobranças à vista -->
      <div class="vx-row mb-6" v-if="formCadastro.idVariacao == 1">
        <div class="vx-col w-full">
          <span>Com Cobranças à vista</span>
          <v-select
            class="style-chooser"
            :options="respostas"
            name="Com Cobranças à vista"
            id="Com Cobranças à vista"
            v-model="formCadastro.jsonFacilitador.comCobranca"
            v-validate="{ required: true }"
            :state="
              validateState(
                this.veeFields,
                this.veeErrors,
                'Com Cobranças à vista',
              )
            "
            :class="
              validateClass(
                this.veeFields,
                this.veeErrors,
                'Com Cobranças à vista',
              )
            "
          ></v-select>
        </div>
      </div>

      <!-- Com outras Cobranças Vencidas -->
      <div class="vx-row mb-6" v-if="formCadastro.idVariacao == 2">
        <div class="vx-col w-full">
          <span>Com outras Cobranças Vencidas</span>
          <v-select
            class="style-chooser"
            :options="respostas"
            name="Com outras Cobranças Vencidas"
            id="Com outras Cobranças Vencidas"
            v-model="formCadastro.jsonFacilitador.outrasCobrancas"
            v-validate="{ required: true }"
            :state="
              validateState(
                this.veeFields,
                this.veeErrors,
                'Com outras Cobranças Vencidas',
              )
            "
            :class="
              validateClass(
                this.veeFields,
                this.veeErrors,
                'Com  outras Cobranças Vencidas',
              )
            "
          ></v-select>
        </div>
      </div>

      <!-- Quant. de dias -->
      <div class="vx-row mb-6" v-if="formCadastro.idVariacao == 3">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            label="Quant. de dias"
            type="number"
            v-model="formCadastro.jsonFacilitador.qtdDias"
            name="Quant. de dias"
            v-validate="{ required: true }"
            :state="
              validateState(this.veeFields, this.veeErrors, 'Quant. de dias')
            "
            :class="
              validateClass(this.veeFields, this.veeErrors, 'Quant. de dias')
            "
          />
        </div>
      </div>

      <!-- Possui mais de um veículo Ativo -->
      <div class="vx-row mb-6" v-if="formCadastro.idVariacao == 4">
        <div class="vx-col w-full">
          <span>Possui mais de um veículo Ativo</span>
          <v-select
            class="style-chooser"
            :options="respostas"
            name="Possui mais de um veículo Ativo"
            id="Possui mais de um veículo Ativo"
            v-model="formCadastro.jsonFacilitador.maisVeiculos"
            v-validate="{ required: true }"
            :state="
              validateState(
                this.veeFields,
                this.veeErrors,
                'Possui mais de um veículo Ativo',
              )
            "
            :class="
              validateClass(
                this.veeFields,
                this.veeErrors,
                'Possui mais de um veículo Ativo',
              )
            "
          ></v-select>
        </div>
      </div>

      <!-- Status Associado -->
      <h5 class="my-2">Beneficiário</h5>
      <div class="vx-row mb-6">
        <div class="vx-col w-1/2">
          <span class="my-2 chip">Status Atual</span>
          <v-select
            class="style-chooser"
            multiple
            :options="listaStatusAssociados"
            name="Status Beneficiário Atual"
            id="Status Beneficiário Atual"
            label="nomeStatus"
            :reduce="(item) => item.idStatus"
            v-model="formCadastro.idStatusAssociadoAnterior"
          ></v-select>
        </div>
        <div class="vx-col w-1/2">
          <span class="my-2 chip chip-success">Novo Status</span>
          <v-select
            class="style-chooser"
            :options="[
              { idStatus: null, nomeStatus: 'Sem Alteração' },
              ...listaStatusAssociados,
            ]"
            name="Novo Status Beneficiário"
            id="Novo Status Beneficiário"
            label="nomeStatus"
            :reduce="(item) => item.idStatus"
            v-model="formCadastro.idStatusAssociado"
            :state="
              validateState(
                this.veeFields,
                this.veeErrors,
                'Novo Status Benefíciario',
              )
            "
            :class="
              validateClass(
                this.veeFields,
                this.veeErrors,
                'Novo Status Benefíciario',
              )
            "
          ></v-select>
        </div>
      </div>

      <!-- Status Veículo -->
      <h5 class="my-2">Veículo</h5>
      <div class="vx-row mb-6">
        <div class="vx-col w-1/2">
          <span class="my-2 chip">Status Atual</span>
          <v-select
            class="style-chooser"
            multiple
            :options="listaStatusVeiculos"
            name="StatusVeículoAtual"
            id="StatusVeículoAtual"
            label="nomeStatus"
            :reduce="(item) => item.idStatus"
            v-model="formCadastro.idStatusVeiculoAnterior"
          ></v-select>
        </div>
        <div class="vx-col w-1/2">
          <span class="my-2 chip chip-success">Novo Status</span>
          <v-select
            class="style-chooser"
            :options="[
              { idStatus: null, nomeStatus: 'Sem Alteração' },
              ...listaStatusVeiculos,
            ]"
            name="Novo Status Veículo"
            id="Novo Status Veículo"
            label="nomeStatus"
            :reduce="(item) => item.idStatus"
            v-model="formCadastro.idStatusVeiculo"
          ></v-select>
        </div>
      </div>

      <!-- Depende de Aprovacao -->
      <div class="vx-row mb-6 mt-6">
        <div class="vx-col w-full">
          <label>Depende de Aprovação</label>
          <vs-switch
            class="mb-3"
            v-model="formCadastro.dependeAprovacao"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>

          <vs-alert
            color="warning"
            title="Atenção!!"
            active="true"
            v-if="formCadastro.dependeAprovacao"
          >
            As alterações de status não serão processadas automaticamente,
            precisam de aprovação para serem executadas.
          </vs-alert>
        </div>
      </div>

      <!-- Alertas Erros -->
      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>

      <div class="vx-row">
        <div class="vx-col w-full text-right mt-5">
          <vs-button color="success" class="mr-3 mb-2">{{
            formCadastro.idVariacaoEmpresa ? 'Atualizar' : 'Adicionar'
          }}</vs-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import vSelect from 'vue-select';

import service from '../../../../services';
import utils from './../../../../utils/list';
import notify from '../../../../utils/notify';

const formCadastroReset = {
  idVariacaoEmpresa: null,
  idEmpresa: null,
  idVariacao: null,
  idStatusAssociado: null,
  idStatusVeiculo: null,
  jsonFacilitador: {},
  idStatusAssociadoAnterior: null,
  idStatusVeiculoAnterior: null,
  dependeAprovacao: false,
};

export default {
  props: [
    'listaStatusAssociados',
    'listaStatusVeiculos',
    'idEmpresa',
    'maquinaStatusVariacoes',
    'objUpdate',
  ],
  watch: {
    objUpdate(value) {
      if (value) {
        this.preencheForm();
        return;
      }

      this.resetForm();
    },
  },
  data() {
    return {
      funcoesValicao: null,
      respostas: ['Sim', 'Não'],
      formCadastro: { ...formCadastroReset },
      validateClass: utils.validateStateClass,
      validateState: utils.validateState,
    };
  },
  methods: {
    preencheForm() {
      if (this.objUpdate.id_variacao_empresa) {
        if (this.objUpdate.jsonFacilitador != '') {
          var json = JSON.parse(this.objUpdate.jsonFacilitador);

          this.formCadastro.jsonFacilitador.comCobranca = json.comCobranca;
          this.formCadastro.jsonFacilitador.outrasCobrancas =
            json.outrasCobrancas;
          this.formCadastro.jsonFacilitador.qtdDias = json.qtdDias;
          this.formCadastro.jsonFacilitador.maisVeiculos = json.maisVeiculos;
        }

        this.formCadastro.idVariacaoEmpresa =
          this.objUpdate.id_variacao_empresa;
        this.formCadastro.idEmpresa = this.objUpdate.id_empresa;
        this.formCadastro.idVariacao = this.objUpdate.id_variacao;
        this.formCadastro.idStatusAssociado =
          this.objUpdate.id_status_associado;
        this.formCadastro.idStatusVeiculo = this.objUpdate.id_status_veiculo;
        this.formCadastro.idStatusAssociadoAnterior =
          this.objUpdate.idStatusAssociadoAnterior;
        this.formCadastro.idStatusVeiculoAnterior =
          this.objUpdate.idStatusVeiculoAnterior;
        this.formCadastro.dependeAprovacao = this.objUpdate.dependeAprovacao;
      }
    },
    limpaJsonFacilitador() {
      this.formCadastro.jsonFacilitador = {};
    },
    resetForm() {
      this.formCadastro = { ...formCadastroReset };
      this.$validator.reset();
    },
    async onSubmit() {
      const formValidado = await this.$validator.validateAll();

      if (!formValidado) {
        return;
      }

      try {
        this.$vs.loading();

        const result = await service.post(
          'status',
          'upsert',
          this.formCadastro,
        );

        notify.notifySuccess(this.$vs, 'Operação Realizada com sucesso');
        this.resetForm();
        this.$emit('add', result);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  components: {
    'v-select': vSelect,
  },
};
</script>

<style>
.style-chooser .vs__dropdown-menu {
  max-height: 100px;
}

.chip {
  background: rgb(7, 143, 207);
  color: rgba(255, 255, 255, 0.9);
  border-radius: 0.25rem !important;
  padding: 2px 4px;
  font-weight: 700;
  display: inline-block !important;
}

.chip-success {
  background: rgba(var(--vs-success), 1);
}
</style>
